import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { csmList, csmDelete } from "../../../../store/actions/memberActions";
import { Popconfirm, message, Empty } from "antd";
import { MaskEmail, MaskPhoneNumber } from "../../../../utils/helper";
import TableWrapper from "../../../../components/Tables";
import Pagination from "../../../../components/Pagination";

const CSMIndex = () => {
  const [search, setsearch] = useState("");
  let dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    dispatch(csmList(1, search));
    localStorage.removeItem("id_csm");
  }, [dispatch]);

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("csm-read")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);

  const datacsmList = useSelector((state) => state.csmList);
  const { csm, listsCsm } = datacsmList;

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  const handleEdit = (id) => {
    localStorage.setItem("id_csm", id);
    history.push("/csm-edit");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(csmList(1, search));
  };

  const tableHead = [
    { name: "No" },
    { name: "Name" },
    { name: "Email" },
    { name: "Phone" },
    { name: "Office" },
    { name: "Join Date" },
    { name: "Status" },
    { name: "Action" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.name },
    { render: (item) => <MaskEmail item={item} /> },
    { render: (item) => <MaskPhoneNumber item={item} /> },
    { render: (item) => item.office },
    { render: (item) => item.join_date },
    {
      render: (item) => (
        <span
          className={
            item.status === "Active"
              ? "badge badge-success"
              : "badge badge-danger"
          }
        >
          {item.status}
        </span>
      ),
    },
    {
      render: (item) => (
        <div align="center">
          {userInfo.permission.find((e) => e === "csm-edit") ? (
            <button
              onClick={() => handleEdit(item.id)}
              className="btn btn-warning btn-sm"
            >
              <i className="fa fa-pencil"></i> Edit{" "}
            </button>
          ) : null}
          {userInfo.permission.find((e) => e === "csm-delete") ? (
            <Popconfirm
              title="Are you sure to delete this parent?"
              onConfirm={() =>
                dispatch(csmDelete(item.id)).then(() =>
                  dispatch(csmList(1, search))
                )
              }
              onCancel={() => message.info("Canceled!")}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-danger btn-sm">
                <i className="fa fa-trash-o"></i> Delete{" "}
              </button>
            </Popconfirm>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>CSM</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  {userInfo.permission.find((e) => e === "csm-create") ? (
                    <Link to={"/csm-create"} className="btn btn-info btn-sm">
                      Create
                    </Link>
                  ) : null}
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "50%", textOverflow: "ellipsis", paddingRight: "33px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper
                datas={listsCsm}
                tableHead={tableHead}
                tableBody={tableBody}
              />
              <Pagination
                datas={csm}
                listsData={csmList}
                search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CSMIndex;
